var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" }, [
            _vm.properties.uid
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: form.id } }, [
                                _vm._v(_vm._s(form.name) + " "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "tx-danger has-text-weight-semibold"
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.orderData[form.id],
                                    expression: "orderData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.orderData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.orderData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.orderData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.orderData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [_vm._v(_vm._s(form.name))]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.orderData[form.id],
                                        expression: "orderData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.orderData[form.id],
                                      checked: _vm._q(
                                        _vm.orderData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.orderData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "d-block has-text-weight-semibold",
                              attrs: { for: "formGroupExampleInput" }
                            },
                            [_vm._v(_vm._s(form.name))]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mg-b-0 text-left" }, [
                            _vm._v(_vm._s(_vm.orderData[form.id]))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: form.id } }, [
                                _vm._v(_vm._s(form.name) + " "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "tx-danger has-text-weight-semibold"
                                  },
                                  [_vm._v("*")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.orderData[form.id],
                                    expression: "orderData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.orderData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.orderData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [_vm._v(_vm._s(form.name))]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.orderData[form.id],
                                        expression: "orderData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.orderData[form.id],
                                      checked: _vm._q(
                                        _vm.orderData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.orderData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("Detail")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " Detail")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.confirmData()
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "folder" }
                      }),
                      _vm._v("Confirm")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.createData(true)
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "folder" }
                      }),
                      _vm._v("Save")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.properties.uid
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"
                        },
                        [
                          _c("feather", {
                            staticClass:
                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                            attrs: { type: "delete" }
                          }),
                          _vm._v("delete")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.goPage()
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass:
                          "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                        attrs: { type: "file" }
                      }),
                      _vm._v("List")
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c("div", { staticClass: "col-sm-6 col-lg-5" }, [
              _c(
                "ul",
                {
                  staticClass: "cardborder nav nav-tabs",
                  attrs: { id: "myTab", role: "tablist" }
                },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          id: "experiment-tab",
                          "data-toggle": "tab",
                          href: "#experiment",
                          role: "tab",
                          "aria-controls": "experiment",
                          "aria-selected": "true"
                        },
                        on: { click: this.rendertab }
                      },
                      [_vm._v("Order")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card card-body" }, [
              _c(
                "div",
                {
                  staticClass: "tab-content mg-t-20",
                  attrs: { id: "myTabContent" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade lm-overflow show active",
                      attrs: {
                        id: "experiment",
                        role: "tabpanel",
                        "aria-labelledby": "experiment-tab"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block tx-right-f mg-xs-y-15-f"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                              attrs: {
                                href: "",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "check" }
                              }),
                              _vm._v("all checked")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                              attrs: {
                                href: "",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "minus" }
                              }),
                              _vm._v("delete")
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-line",
                          attrs: { id: "myTab5", role: "tablist" }
                        },
                        _vm._l(_vm.tabHeader, function(form, i) {
                          return _vm.properties.mid === form.id
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    },
                                    on: { click: _vm.classifySampleHeader }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                            : _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "profile",
                                      "aria-selected": "false"
                                    },
                                    on: { click: _vm.classifySampleHeader }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("hot-table", {
                        ref: "sheet",
                        staticClass: "ht-hot-table",
                        attrs: {
                          id: "sample-table",
                          settings: _vm.sheetSettings,
                          data: _vm.sampleData,
                          afterChange: _vm.changeData
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade",
                      attrs: {
                        id: "samples",
                        role: "tabpanel",
                        "aria-labelledby": "samples-tab"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-block tx-right-f mg-xs-y-15-f"
                        },
                        [
                          _vm.reOrderButtons
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                  attrs: {
                                    href: "",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelReOrder("cancel")
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "delete" }
                                  }),
                                  _vm._v("발주취소")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.reOrderButtons
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                  attrs: {
                                    href: "",
                                    "data-toggle": "modal",
                                    "data-animation": "effect-flip-horizontal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelReOrder("disposal")
                                    }
                                  }
                                },
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "trash-2" }
                                  }),
                                  _vm._v("폐기요청")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                              attrs: {
                                href: "",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              },
                              on: { click: _vm.sampleAddColumn }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "plus" }
                              }),
                              _vm._v("Add")
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-line",
                          attrs: { id: "myTab5", role: "tablist" }
                        },
                        _vm._l(_vm.tabHeader, function(form, i) {
                          return _vm.tabHeader.length - 2 === i
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "home",
                                      "aria-selected": "true"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifyWorkChange(form.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(form.menuName))]
                                )
                              ])
                            : _vm.tabHeader.length - 1 === i
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      id: form.id,
                                      "data-toggle": "tab",
                                      href: "#",
                                      role: "tab",
                                      "aria-controls": "profile",
                                      "aria-selected": "false"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.classifyWorkChange(form.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Re-Order")]
                                )
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-table",
                            {
                              ref: "table",
                              attrs: {
                                id: "preTable",
                                data: _vm.isEmpty ? [] : _vm.preData,
                                "checked-rows": _vm.checkedRows,
                                hoverable: "",
                                striped: "",
                                checkable: "",
                                detailed: "",
                                "detail-key": "id",
                                "show-detail-icon": false,
                                "opened-detailed": _vm.defaultOpenedDetails
                              },
                              on: {
                                "update:checkedRows": function($event) {
                                  _vm.checkedRows = $event
                                },
                                "update:checked-rows": function($event) {
                                  _vm.checkedRows = $event
                                },
                                "details-open": function(row, index) {
                                  return _vm.closeAllOtherToggle(row, index)
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(props) {
                                    return _vm._l(_vm.preHeader, function(
                                      form,
                                      i
                                    ) {
                                      return Number(i) == 0
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: "no",
                                                label: "No",
                                                centered: ""
                                              }
                                            },
                                            [_vm._v(_vm._s(props.row.no))]
                                          )
                                        : Number(i) == 1
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#",
                                                    id: props.index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggle(
                                                        props.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row[
                                                          form.columnCode
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.row[form.columnCode]
                                                )
                                              )
                                            ]
                                          )
                                    })
                                  }
                                },
                                {
                                  key: "detail",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "nav nav-line",
                                          attrs: {
                                            id: "myTab5",
                                            role: "tablist"
                                          }
                                        },
                                        _vm._l(_vm.tabHeader, function(
                                          form,
                                          i
                                        ) {
                                          return form.id == _vm.re_orderId
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "nav-link active",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "true"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.classifyPreSampleHeader
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm.re_orderId.length == 0 &&
                                              i == 0
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "nav-link active",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "false"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.classifyPreSampleHeader
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm.tabHeader.length - 2 >= i
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "nav-link",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "false"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.classifyPreSampleHeader
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("b-table", {
                                        ref: "sampleTable",
                                        attrs: {
                                          id: "preSampleTable",
                                          columns: _vm.preSampleHeader,
                                          data: _vm.isEmpty
                                            ? []
                                            : _vm.preSampleData,
                                          "checked-rows": _vm.sampleCheckedRows,
                                          hoverable: "",
                                          striped: "",
                                          checkable: ""
                                        },
                                        on: {
                                          "update:checkedRows": function(
                                            $event
                                          ) {
                                            _vm.sampleCheckedRows = $event
                                          },
                                          "update:checked-rows": function(
                                            $event
                                          ) {
                                            _vm.sampleCheckedRows = $event
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _c("section", { staticClass: "section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "content has-text-grey has-text-centered"
                                    },
                                    [_c("p", [_vm._v("Nothing here.")])]
                                  )
                                ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-none" },
                            [
                              _c("b-table", {
                                ref: "sampleTable",
                                attrs: { id: "preSampleTable" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            id: "samples-tab",
            "data-toggle": "tab",
            href: "#samples",
            role: "tab",
            "aria-controls": "samples",
            "aria-selected": "false"
          }
        },
        [_vm._v("Samples")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6311f770", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6311f770","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/DetailForm.vue
// module id = null
// module chunks = 